import { render, staticRenderFns } from "./IconLogo.vue?vue&type=template&id=e6a8d178&scoped=true&"
var script = {}
import style0 from "./IconLogo.vue?vue&type=style&index=0&id=e6a8d178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a8d178",
  null
  
)

export default component.exports